import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';

interface UseFormFieldProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  defaultValue?: any;
}

export function useFormField<T extends FieldValues>({ 
  name, 
  control, 
  defaultValue 
}: UseFormFieldProps<T>) {
  const {
    field,
    fieldState: { error }
  } = useController({
    name,
    control,
    defaultValue,
  });

  return {
    ...field,
    error: error?.message,
  };
}